import { Button } from "antd";
import { translate } from "shared/languages";
import { colors } from "shared/theme/color";

// Shared Reset Filter button used by both the calendar filter panel and the
// list filter row. Muted/subtle when no filters are active; solid ink when one
// or more filters are selected, so it reads as actionable.
export const ResetFilterButton = ({
  active,
  onReset,
  block = false,
}: {
  active: boolean;
  onReset: () => void;
  block?: boolean;
}) => (
  <Button
    block={block}
    type={active ? "primary" : "default"}
    onClick={onReset}
    style={{ borderRadius: 8, ...(active ? {} : { color: colors.ink3 }) }}
  >
    {translate("schedule.reset_filter")}
  </Button>
);
